<template>
  <div class="contacts-wrapper">

    <app-header></app-header> <hr>

     <div class="container">
          
          <div class="row bg-light mb-5">

              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 py-4">
                 <h3 class="text-center">Our Location on <span class="text-primary">Map</span></h3>
                 <hr>
              </div> 
           
             <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                 <iframe 
                    src="https://maps.google.com/maps?width=100%&amp;height=600&amp;hl=en&amp;q=Regimanuel%20Gray%20Estate%2C%20Clubhouse+(My%20Business%20Name)&amp;ie=UTF8&amp;t=&amp;z=18&amp;iwloc=B&amp;output=embed"
                    width="100%"
                    height="700px"
                    frameborder="0"
                    style="border:0"
                    allowfullscreen>
                  </iframe>
             </div>

          </div>

     </div>

    <app-footer></app-footer>
    
  </div>
</template>

<script>
import Header from '@/components/layout/NewHeader'
import Footer from '@/components/layout/NewFooter'
export default {
  components: {
    'app-header': Header,
    'app-footer': Footer,
  }
}
</script>

<style lang="scss" scoped>
.contacts {
  max-width: 1200px;
  padding: 86px 0 79px 0;
  margin: 0 auto;
  @media screen and (max-width: 1200px) {
    margin: 0 30px;
  }
  &-wrapper {
    width:100%;
  }
  &-title {
    font-family: "Optimal C";
    font-size: 30px;
    font-weight: 400;
    text-transform: uppercase;
    letter-spacing: 0.18px;
    &_border {
      width: 63px;
      height: 3px;
      background-color: #2a9854;
    }
  }
  &__row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top:68px;
    height:340px;
    @media screen and (max-width: 720px) {
      flex-direction: column-reverse;
      height: auto;
    }
    &__map {
      width:60%;
      @media screen and (max-width: 720px) {
        width:100%;
        height:340px;
      }
    }
    &__items {
      display: flex;
      flex-direction: column;
      justify-content: center;
      width:35%;
      @media screen and (max-width: 720px) {
        width:100%;
        flex-direction: row;
        justify-content: flex-start;
      }
      @media screen and (max-width: 480px) {
        flex-direction: column;
      }
      &__item {
        display: flex;
        flex-direction: row;
        &-phone {
          @media screen and (max-width: 720px) and (min-width: 480px) {
            align-items: flex-start;
            img {
              height:50%;
              margin-left: 30px;
            }
          }
        }
        img {
          margin-right:16px;
          padding-left:1px;
          width:15px;
        }
        &-text {
          color: #38383a;
          font-family: "Open Sans";
          font-size: 16px;
          font-weight: 400;
          line-height: 26px;
          letter-spacing: 0.4px;
        }
      }
    }
  }
}
</style>